import { render, staticRenderFns } from "./message-input.html?vue&type=template&id=535464cc&scoped=true&"
import script from "./message-input.js?vue&type=script&lang=ts&"
export * from "./message-input.js?vue&type=script&lang=ts&"
import style0 from "./message-input.scss?vue&type=style&index=0&id=535464cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535464cc",
  null
  
)

export default component.exports